import * as colors from 'components/common/colorConstants';
import styled from 'styled-components/macro';
import { Section } from './CenterInfoPanel.styles';

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const AmazonContext = styled(Section)`
  label {
    cursor: pointer;
    padding-top: 8px;
    transition: color ease 0.3s;
  }
  p {
    line-height: 2;
    padding: 4px 0px;
  }
  span {
    color: ${colors.whiteText};
  }
  a {
    color: ${colors.whiteText};
  }
  & .link {
    text-decoration: underline;
  }
  & .product-page {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 139px;
    display: block;
    overflow: hidden;
  }
  ul {
    margin-bottom: 0;
    padding-bottom: 4px;
    list-style-type: none;
    padding-left: 0;
    font-size: 11px;
    color: ${colors.lightGray1};
  }
  li {
    margin: 2px 0px;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
  }
  img {
    max-width: 10px;
    cursor: pointer;
    top: 11px;
  }
  & .down-arrow {
    top: 11px;
    cursor: pointer;
  }
  & .up-arrow {
    transform: rotate(-180deg);
  }
  & .active {
    max-height: 844px;
    transition: max-height ease 0.7s;
  }
  & .inactive {
    max-height: 0px;
    opacity: 0;
    overflow: hidden;
    transition: all ease 0.7s;
  }
  & .hover {
    background-color: black;
    text-color: white;
  }
`;
